import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Usuario } from '@/Interfaces';

@Injectable({ providedIn: 'root' })

export class UsuarioService {
    //urlApiOficinaVirtual:String = null;
    constructor(private http: HttpClient
        
    ) { }

    getAll() {
        
        return this.http.get<Usuario[]>(`http://localhost:4000/users`);
    }

    register(user: Usuario) {
        
        return this.http.post(`http://localhost:4000/users/register`, user);
    }

    delete(id: number) {
        return this.http.delete(`http://localhost:4000/users/${id}`);
    }
}